<h1 mat-dialog-title class="notification-title">
	{{ 'mes.administration.shift-approval.merge.dialog-header' | translate }}
</h1>
<mat-dialog-content>
	<dl class="merge-summary">
		<div>
			<dt>{{ 'mes.administration.shift-approval.merge.summary.employee' | translate }}</dt>
			<dd>{{ data.employeeName }}</dd>
		</div>
		<div>
			<dt>{{ 'mes.administration.shift-approval.merge.summary.shifts' | translate }}</dt>
			<dd>{{ data.shiftIds.length }}</dd>
		</div>
		<div>
			<dt>{{ 'mes.administration.shift-approval.merge.summary.period' | translate }}</dt>
			<dd>
				@if (data.end) {
					{{
						'mes.administration.shift-approval.merge.summary.period-closed'
							| translate
								: {
										start: data.start | date: 'dd-MM-yyyy HH:mm',
										end: data.end | date: 'dd-MM-yyyy HH:mm',
								  }
					}}
				} @else {
					{{ 'mes.administration.shift-approval.merge.summary.period-open' | translate: { start: data.start | date: 'dd-MM-yyyy HH:mm' } }}
				}
			</dd>
		</div>
	</dl>
	<p class="gap-explanation">
		{{ 'mes.administration.shift-approval.merge.gap-explanation' | translate }}
	</p>
	<app-worktask-select
		[value]="gapWorkTaskId"
		(valueChange)="onGapWorkTaskChange($event)"
		[worktasks]="data.worktasks"
		[fullWidth]="true"
		[excludeOfftask]="true"
		[includeNoneOption]="true"
		[noneText]="'mes.administration.shift-approval.merge.gap-worktask.none' | translate"
		[label]="'mes.administration.shift-approval.merge.gap-worktask.label' | translate"
		[placeholder]="'mes.administration.shift-approval.merge.gap-worktask.placeholder' | translate"
		[filterPlaceholder]="'mes.administration.shift-approval.create-shift-note.worktask.filter-placeholder' | translate"></app-worktask-select>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-stroked-button type="button" (click)="cancel()" [disabled]="loading">
		{{ 'mes.administration.shift-approval.create-shift-note.buttons.cancel' | translate }}
	</button>
	<button mat-flat-button color="primary" type="button" (click)="merge()" [disabled]="loading">
		{{ 'mes.administration.shift-approval.merge.confirm' | translate }}
	</button>
</mat-dialog-actions>
